import { METER_READINGS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/meter_readings_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['METER_ASSOCIATED_METER_READINGS']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
